import { graphql, withApollo } from '@apollo/client/react/hoc'
import { compose } from 'redux'
import get from 'lodash-es/get'
import { GET_FACILITY_QUERY } from '../queries'
import { withParams } from '~/utils/reactRouterHOC'

function getParams(props) {
  const { id, floorId = null, versionId = null } = get(props, 'params')
  const _id = id || get(props, 'facility.id') || get(props, 'id')
  const _floorId = floorId || get(props, 'facility.floor.id') || get(props, 'floorId') || null
  const _versionId = versionId || get(props, 'facility.floor.version.id') || get(props, 'versionId') || null
  return { id: _id, floorId: _floorId, versionId: _versionId }
}

export default compose(
  withParams,
  withApollo,
  graphql(GET_FACILITY_QUERY, {
    options: props => {
      const { id, floorId, versionId } = getParams(props)
      return {
        variables: {
          id,
          floorId,
          versionId,
        },
      }
    },
    props: ({ data, ownProps }) => {
      let facility = data.facility
      if (!facility) {
        const { id, floorId, versionId } = getParams(ownProps)
        facility = ownProps.client.readQuery({
          query: GET_FACILITY_QUERY,
          variables: {
            id,
            floorId,
            versionId,
          },
        })
      }

      return {
        loading: get(data, 'loading') || get(ownProps, 'loading'),
        facility,
      }
    },
  })
)
